import {migration_20250301_initial_migration} from '@/features/settings/store/migrations/20250301-initial-migration';
import {migration_20250302_add_theme} from '@/features/settings/store/migrations/20250302-add-theme';
import {
  SETTINGS_STORE_DEFAULT_STATE,
  SettingsState,
} from '@/features/settings/store/settings-slice';

const migrateSettings = (state: unknown, version: number): SettingsState => {
  if (typeof state !== 'object' || state === null) {
    return SETTINGS_STORE_DEFAULT_STATE;
  }

  const v0_state = migration_20250301_initial_migration(state, version);
  const v1_state = migration_20250302_add_theme(v0_state, version);

  return v1_state;
};

export {migrateSettings};
